import { env } from './environment-types';

export const environment = env({
	name: 'uat',
	production: false,
});
